import {
  Space,
  Dropdown,
  message,
  Modal,
  Tooltip,
  Tag
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  EditOutlined,
  HomeOutlined,
  MenuOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import StateModal from "./component/StateModal";
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {

  const initTableHead = {
    name: undefined,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("StateEdit") || commonFn.btnAuthorityFlag("StateDelete")) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag("StateEdit") && {
                key: "edit",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit</div>,
              },
              commonFn.btnAuthorityFlag("StateDelete") && {
                key: "delete",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Delete</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    {
      title: "Name",
      dataIndex: "name",
      titleType: 'Input',
      // isSorter: true,
      // sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'name'),
    },
    {
      title: 'Status',
      dataIndex: "active",
      titleType: 'Select',
      // isSorter: true,
      // sortterMultiple: 3,
      selectOptions: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 2 },
      ],
      onChange: e => tableFilterFn(e, 'active', 'Select'),
      render: (text, record) => {
        const {id} = record
        const isActive = text === 1;
        const handleClick = () => {
          Modal.confirm({
            title: "Confirm Status Change",
            content: (
              <span>
                Are you sure you want to change the status to
                <span style={{ color: "#1890ff", fontWeight: 500 }}>
                  {isActive? " Inactive" : " Active"}
                </span>
                ?
              </span>
            ),
            okText: "Confirm",
            cancelText: "Cancel",
            style: {
              top: "40%",
            },
            onOk: async () => {
                const response = await http.post(api.updateStateStatus, {id, active: isActive ? 2 : 1});
                if (response?.code === "1") {
                  message.success("Status updated successfully");
                  setTableHead(pre => {
                    getTableListFn(pagination.current, pagination.pageSize, pre);
                    return pre
                  })
                }
            },
          });
        };
        return (
          <Tag
            color={isActive ? "green" : "red"}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            { isActive ? "Active" : "Inactive" }
          </Tag>
        );
      },
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.post(api.getStatePage, params);
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 25,
      total: 0,
    })
    setTableList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const [currentRecord, setCurrentRecord] = useState(null);

  // 新增修改
  const StateRef = useRef(null);

  const newFn = () => {
    StateRef.current.openModal({
      type: 'add',
      modalName: 'New State',
    })
  }

  const customModalRef = useRef(null);

  const handleMenuClick = async (item, record) => {
    const { key } = item
    setCurrentRecord(record);
    if(['edit'].includes(key)){
      StateRef.current.openModal({
        oldState: record,
        type: 'edit',
        modalName: 'Edit State',
      })
    }else if(['delete'].includes(key)) {
      customModalRef.current.openModalFn();
    }
  }

  const deleteFn = async () => {
    const response = await http.get(api.delState, {
      params: {
        ids: currentRecord.id
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn();
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  const submitInitFn = () => {
    getTableListFn();
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('StateDownload') && 'download']}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("StateNew") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: newFn },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
           )) || null}
        </div>
      </CustomTableExtend>
      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
      />

      <StateModal
        ref={StateRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          deleteContent: currentRecord?.modalName,
          onOkFn: deleteFn,
        }} 
      />
    </div>
  );
});
export default MainTable;
